export default {
  CPC: "CPC",
  Fixed: "Flat Rate",
};
